import { LineChartGraph } from '@/common/components/LineChart'

interface GraphData {
	week: string
	deposits: number
	firstDeposits: number
	withdrawals: number
	bonus: number
	[key: string]: string | number
}

interface GraphSummaryGraphProps {
	data: GraphData[]
}

export default function GraphSummaryGraph({ data }: GraphSummaryGraphProps) {
	const last7DaysData = data.slice(-7)

	return (
		<LineChartGraph
			data={last7DaysData}
			title="สรุปข้อมูลการเงิน"
			description="แสดงข้อมูล 7 วันล่าสุด"
			dataKeys={{
				deposits: {
					label: 'ยอดฝาก',
					color: '#c200fb',
				},
				firstDeposits: {
					label: 'ยอดฝากครั้งแรก',
					color: '#fbfb00',
				},
				withdrawals: {
					label: 'ยอดถอน',
					color: '#fb0b00',
				},
				bonus: {
					label: 'โบนัส',
					color: '#00cafb',
				},
			}}
		/>
	)
}
